module.exports = __webpack_public_path__ + "img/logo-footer.095379f1.png";